export const orderTypeEnum = {
  PURCHASE: 1,
  SALE: 2,
  ORDER_SERVICE: 3,
};
